import * as React from 'react';
import { cn } from '../../lib/utils';
import { VariantProps, cva } from 'class-variance-authority';

/**
 * Multi-line text input (glp-frontend `components/helpers/textarea`).
 * `aria-invalid` turns the border red, as on `Input`.
 */
const textareaVariants = cva(
  'flex min-h-[80px] w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 aria-[invalid=true]:border-red-500 !m-0',
  {
    variants: {
      variant: {
        rounded: 'rounded-[19px] border-[2px] !border-slate-200',
      },
    },
    defaultVariants: {},
  },
);

export interface TextareaProps
  extends React.TextareaHTMLAttributes<HTMLTextAreaElement>,
    VariantProps<typeof textareaVariants> {}

const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, variant, ...props }, ref) => {
    return <textarea className={cn(textareaVariants({ variant, className }))} ref={ref} {...props} />;
  },
);
Textarea.displayName = 'Textarea';

export { Textarea, textareaVariants };
